(() => {
  const key = 'savaAttributionV1';
  const fields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
  let ready = !!window.Shopify?.customerPrivacy;
  let queued = [];
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const clean = value => /^[a-zA-Z0-9_. -]{1,100}$/.test(value || '') ? value : '';
  const current = () => {
    const params = new URLSearchParams(location.search);
    let ref = null;
    try { ref = document.referrer ? new URL(document.referrer) : null; } catch (_) {}
    const external = ref && ref.origin !== location.origin;
    const host = external ? ref.hostname.toLowerCase() : '';
    const data = Object.fromEntries(fields.map(name => [name, clean(params.get(name))]));
    data.source = data.utm_source || (/(^|\.)(chatgpt\.com|chat\.openai\.com)$/.test(host) ? 'chatgpt' : host || (ref ? 'internal_unknown' : 'direct_unknown'));
    data.landing_page = location.pathname;
    data.time = Date.now();
    return { data, newVisit: !!(data.utm_source || external) };
  };
  const read = () => {
    if (!allowed()) return null;
    try {
      const data = JSON.parse(sessionStorage.getItem(key) || 'null');
      return data && Date.now() - data.time < 30 * 60 * 1000 ? data : null;
    } catch (_) { return null; }
  };
  const get = () => read() || current().data;
  const populate = () => {
    const data = get();
    document.querySelectorAll('[data-sava-attribution]').forEach(input => {
      input.value = data[input.dataset.savaAttribution] || '';
    });
  };
  const capture = () => {
    ready = true;
    if (allowed()) {
      const visit = current();
      const data = visit.newVisit ? visit.data : read() || visit.data;
      try { sessionStorage.setItem(key, JSON.stringify(data)); } catch (_) {}
    } else {
      try { sessionStorage.removeItem(key); } catch (_) {}
    }
    populate();
    const events = queued;
    queued = [];
    events.forEach(([event, extra]) => track(event, extra));
  };
  const track = (event, extra = {}) => {
    if (!ready) { if (queued.length < 10) queued.push([event, extra]); return; }
    if (!allowed()) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, form_id: 'SavaProjectForm', ...extra });
  };
  window.SavaAttribution = { get, populate, track };
  document.addEventListener('visitorConsentCollected', capture);
  if (window.Shopify?.customerPrivacy) capture();
  else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (!error) capture();
    });
  }
  populate();
})();
